import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "emoji-doh",
  "use": "emoji-doh-usage",
  "viewBox": "0 0 88 88",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 88 88\" id=\"emoji-doh\">\n  <rect x=\"41\" y=\"59\" width=\"6\" height=\"6\" />\n  <rect x=\"30\" y=\"41\" width=\"6\" height=\"6\" />\n  <rect x=\"52\" y=\"41\" width=\"6\" height=\"6\" />\n  <rect x=\"18\" y=\"35\" width=\"12\" height=\"6\" />\n  <rect x=\"18\" y=\"47\" width=\"12\" height=\"6\" />\n  <rect x=\"58\" y=\"35\" width=\"12\" height=\"6\" />\n  <rect x=\"58\" y=\"47\" width=\"12\" height=\"6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol